import React, { FunctionComponent } from 'react'
import { T } from '@transifex/react'
import { useAppSelector } from '../../../state/hooks'
import { selectSaleSummaryFields } from '../../../state/slices/currentSale/currentSaleSlice'
import { getCashDiscountedSaleTotal } from '../../../functions/sale'
import { useFormatCurrencyValue } from './useFormatCurrencyValue'

export const CashDiscountSection: FunctionComponent = () => {
  const saleSummary = useAppSelector(selectSaleSummaryFields)
  const formatCurrencyValue = useFormatCurrencyValue()

  return (
    <section className="sale-summary-section sale-summary-section--indent">
      <ul className="sale-summary-list">
        <li className="sale-summary-line sale-summary-line--total">
          <div className="sale-summary-line-item sale-summary-line-item--label">
            <T
              _str="Total"
              _context="Cash discount total label in sale summary"
            />
          </div>
          <div className="sale-summary-line-item sale-summary-line-item--value">
            {formatCurrencyValue(
              getCashDiscountedSaleTotal({
                finals: saleSummary.finals,
                totals: saleSummary.totals,
              })
            )}
          </div>
        </li>
        <li className="sale-summary-line sale-summary-line--total">
          <div className="sale-summary-line-item sale-summary-line-item--label">
            <T
              _str="Cash discount"
              _context="Cash discount label in sale summary"
            />
          </div>
          <div className="sale-summary-line-item sale-summary-line-item--value">
            {formatCurrencyValue(saleSummary.totals.cashDiscount)}
          </div>
        </li>
      </ul>
    </section>
  )
}
